      
import React from 'react';
import './Tbakelites.css';
import Tbakelite from '../../../imgs/Tbakelite.webp'; 

const Tbakelites = () => {
  return (
    <div className="Tbakelit-container" data-aos="fade-down">
      <img src={Tbakelite} alt="Fitting Corrosion" className="Tbakelit-image" />
    </div>
  );
};

export default Tbakelites;
